// extracted by mini-css-extract-plugin
export default {"container":"authWarning_container__Ej7-d"};